module.exports = __webpack_public_path__ + "static/media/email.62dde3d4.svg";